import type { SVGProps } from "react";
export interface SeedlingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function SeedlingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: SeedlingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M4.521 1.94c1.443-.124 3.385-.144 4.897.46l.527.23q.516.245.983.551l.453.32.088.075a1.125 1.125 0 0 1-1.362 1.777l-.096-.066-.318-.225a6 6 0 0 0-.713-.4l-.398-.173c-.989-.395-2.473-.428-3.868-.308-.425.037-.813.087-1.152.135.145.331.319.707.522 1.096.661 1.26 1.525 2.486 2.495 3.067l.207.112q.325.156.735.252a1.125 1.125 0 0 1-.508 2.191 5.8 5.8 0 0 1-1.207-.418l-.384-.207C3.892 9.49 2.788 7.785 2.09 6.456a20 20 0 0 1-1.056-2.383L.973 3.91l.013.025a1.126 1.126 0 0 1 .844-1.601c-.027.004 1.229-.267 2.691-.393ZM9.875 21a1.125 1.125 0 1 0 2.25 0v-7.102c.382.082.82.163 1.292.225 1.479.192 3.564.245 5.162-.714 1.53-.918 2.64-2.628 3.34-3.96a20 20 0 0 0 1.058-2.391l.063-.175q.01-.033.017-.052l.006-.017q.002-.005.001-.005a1.125 1.125 0 0 0-.79-1.455c-.114-.029-1.3-.29-2.787-.418-1.446-.123-3.395-.141-4.905.463-1.421.569-2.614 1.446-3.447 2.658-.835 1.213-1.26 2.694-1.26 4.387zm7.547-9.52c-.902.541-2.318.593-3.714.412-.586-.077-1.12-.19-1.533-.29.109-.913.396-1.661.814-2.27.542-.787 1.35-1.412 2.429-1.844.989-.395 2.48-.428 3.879-.309.416.036.806.086 1.148.135-.144.327-.315.7-.518 1.087-.665 1.264-1.535 2.497-2.505 3.079"
      />
    </svg>
  );
}
